import * as React from 'react';
import { BodyCell } from '@tableau/widgets-datagrid';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { CreateCellText } from './PlainTextAndNumberCells';
import { Messages } from '../../../../codegen/Localize';
import { IScheduleInfo } from '~src/schedule/types/IScheduleInfo';
import { ScheduleActions } from '~src/schedule/types/ISchedule';

export function LinkedTaskCell(): React.StatelessComponent<BodyCell.Props> {
    return StyledCellFormatter(
      function LinkedTaskCell(props: BodyCell.Props) {
        const row = props.row;
        const schedule = row.data as IScheduleInfo;
        if (schedule.scheduledAction !== ScheduleActions.Flow) {
         return CreateCellText(Messages.linkedTasksNotAvailable());
        } else if (schedule.enabledForLinkedTasks) {
          return CreateCellText(Messages.linkedTasksConfigured());
        } else {
          return CreateCellText(Messages.linkedTasksNotConfigured());
        }
      }
    );
  }
